import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import style from './FTFCBoxes.module.css';

export const timeUnitMap = {
  MINUTES: 'm',
  DAYS: 'D',
  WEEKS: 'W',
  MONTHS: 'M',
  QUARTERS: 'Q',
  YEARS: 'Y', 
};

export const FTFCBoxes = observer(({ softOrder, size }) => {
  const longFtfcs = softOrder.long ?? null;
  const shortFtfcs = softOrder.short ?? null;
  let boxes;
  if (longFtfcs) {
    boxes = longFtfcs.map(
      ({ timeUnit, candleDuration, priceToBreak, achievedTimeFrame }) => {
        return (
          <div
            className={style.box}
            style={{
              backgroundColor: achievedTimeFrame ? colors.green : colors.red,
            }}
            key={`${timeUnit}-${priceToBreak}-${candleDuration}`}
          >
            <Body3 fontWeight={700} color={colors.lightGrey}>{`${candleDuration}${timeUnitMap[timeUnit]}`}</Body3>
          </div>
        );
      }
    );
  } else if (shortFtfcs) {
    boxes = shortFtfcs.map(
      ({ timeUnit, candleDuration, priceToBreak, achievedTimeFrame }) => {
        return (
          <div
            className={style.box}
            style={{
              backgroundColor: achievedTimeFrame ? colors.red : colors.green,
            }}
            key={`${timeUnit}-${priceToBreak}-${candleDuration}`}
          >
            <Body3 fontWeight={700} color={colors.lightGrey}>{`${candleDuration}${timeUnitMap[timeUnit]}`}</Body3>
          </div>
        );
      }
    );
  }
  return (
    <foreignObject x={120} y={0} width={size - 120} height={20}>
      <div className={style.container}>{boxes}</div>
    </foreignObject>
  );
});
